module.exports = __webpack_public_path__ + "img/icon-dapp-coinbase.064a66e4.svg";